<template lang="pug">
.ok-cancel-modal
  b-modal(v-model="_value" size="md" @ok="ok" no-close-on-backdrop no-close-on-esc)
    .register-body
      FormLabel(key-name="テンプレート名" :value="_templateName")
      FormLabel(key-name="タイトル" :value="_templateTitle")
      FormLabel(key-name="本文" :value="_templateText")
      FormLabel(key-name="見ましたボタン" :value="_addReadButtonLabel")
      FormLabel(key-name="既読確認メッセージ" :value="_addOptionTextLabel")
      FormLabel(key-name="返信ボタン" :value="_addReplyButtonLabel")

    template(#modal-footer="{ ok }")
      b-button.btn.modal-ok-btn(@click="ok") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { SendMessageTemplateTableItem } from "@/pc/containers/sendMessages/SendMessageTemplateTable.vue";

import FormLabel from "@/pc/components/forms/FormLabel.vue";

/**
 * ### メッセージ送信テンプレート詳細モーダル
 */
@Component({
  components: {
    FormLabel
  }
})
export default class SendMessageTemplateDetailModal extends Vue {
  /** モーダル表示可否 */
  @Prop()
  value!: boolean;
  /** テンプレート */
  @Prop()
  template!: SendMessageTemplateTableItem;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _templateName(): string {
    if (!this.template) {
      return "";
    }
    return this.template.name;
  }

  get _templateTitle(): string {
    if (!this.template) {
      return "";
    }
    return this.template.title ? this.template.title : "";
  }

  get _templateText(): string {
    if (!this.template) {
      return "";
    }
    return this.template.text ? this.template.text : "";
  }

  get _addOptionTextLabel(): string {
    if (!this.template) {
      return "";
    }
    if (this.template.addOptionText == true) {
      return "つける";
    } else {
      return "つけない";
    }
  }

  get _addReadButtonLabel(): string {
    if (!this.template) {
      return "";
    }
    if (this.template.addReadButton == true) {
      return "つける";
    } else {
      return "つけない";
    }
  }

  get _addReplyButtonLabel(): string {
    if (!this.template) {
      return "";
    }
    if (this.template.addReplyButton == true) {
      return "つける";
    } else {
      return "つけない";
    }
  }

  public ok(): void {
    this.$emit("ok");
    return;
  }
}
</script>
